import { Component, OnDestroy, OnInit, ViewChild, Output,EventEmitter, Input, TemplateRef } from '@angular/core';
import { IUserTokenModel, StarbaseLoginService } from 'starbase-login';
import { StarbaseWizardComponent, IStarbaseWizardStep, StarbaseWizardStep } from 'starbase-wizard';
import { LU_MaterialService, LU_MaterialServiceDetail, ScaleTicketHeader, LU_STContactType, LU_Grid, LU_JobCategory, LU_JobCode, LU_MaterialSubCategory, LU_STUnitOfMeasure, LU_VehicleType, LU_Tax, LU_InvoiceBatch, STContact, Job, CustomerSelectComponent, StarbaseServicesProviderBase, AppGlobalsServiceBase, ScaleTicketStatusEnum, LU_MaterialServiceServiceBase, Site} from 'scaletech-core';
import { JobDataServiceBase } from 'scaletech-jobs';
import { STContactDataService } from '../services/st-contact-data.service';
import { ScaleTicketHeaderServiceBase } from 'scaletech-tickets';
import { ISelectable, FilterParams } from 'starbase-launcher';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';


@Component({
  selector: 'app-reports-invoice-wizard',
  templateUrl: './reports-invoice-wizard.component.html',
  styleUrls: ['./reports-invoice-wizard.component.css']
})
export class ReportsInvoiceWizardComponent implements OnInit {
  @Input() darkMode = false;
  @Input() jobCodes: LU_JobCode[];
  @Input() jobCategories: LU_JobCategory[];
  @Input() contactSvc : STContactDataService;
  @Input() appGlobals: AppGlobalsServiceBase;
  @Input() sbSvcProvider: StarbaseServicesProviderBase;
  @Input() sthSvc: ScaleTicketHeaderServiceBase;
  @Input() jobSvc: JobDataServiceBase;
  @Input() isSingleSelectMode = false;

  @ViewChild('reportsWizard', { static: true }) reportsWizard: StarbaseWizardComponent<FilterParams<ScaleTicketHeader>>;
  @ViewChild('customerSelect') customerSelect: CustomerSelectComponent;
  @ViewChild('step1', { static: true }) step1: TemplateRef<FilterParams<ScaleTicketHeader>>;
  @ViewChild('step2', { static: true }) step2: TemplateRef<FilterParams<ScaleTicketHeader>>;


  @Output() wizardCompletedEmitter = new EventEmitter<FilterParams<ScaleTicketHeader>>();
  @Output() wizardCancelledEmitter = new EventEmitter<FilterParams<ScaleTicketHeader>>();

  isAdmin = false;
  private currentUser: IUserTokenModel;
  public dropdownTypeDebounceTime;
  public showAll = true;
  public isProcessing = false;
  public filterParams: FilterParams<ScaleTicketHeader> = new FilterParams<ScaleTicketHeader>();
  public generateInvoiceReportSteps: IStarbaseWizardStep<FilterParams<ScaleTicketHeader>>[];
  public filter = new FilterParams;
  statuses: any[] = [];
  customers: STContact;
  allCustomers: STContact[] = [];
  jobs: Job[] = [];
  allJobs: Job[] = [];


  private now = new Date();
  private dateCustomClasses = [
    { date: this.now, classes: ['bg-info'] }
  ];
  bsConfig: Partial<BsDatepickerConfig> = {
    isAnimated: true,
    adaptivePosition: true,
    containerClass: 'theme-green',
    showPreviousMonth: true,
    showWeekNumbers: false,
    ranges: [
      {
        value: [new Date(new Date().setHours(0, 0, 0, 0)), new Date()],
        label: 'Today'
      },
      {
        value: [new Date(new Date(new Date().setDate(new Date().getDate() - 1)).setHours(0, 0, 0, 0)), new Date(new Date(new Date().setDate(new Date().getDate() - 1)).setHours(0, 0, 0, 0))],
        label: 'Yesterday'
      },
      {
        value: [new Date(new Date(new Date().setDate(new Date().getDate() - 7)).setHours(0, 0, 0, 0)), new Date()],
        label: 'Previous 7 Days'
      },
      {
        value: [new Date(new Date(new Date().setMonth(new Date().getMonth() - 6, 1)).setHours(0, 0, 0, 0)), new Date()],
        label: 'Previous 6 Months'
      },
      {
        value: [new Date(new Date(new Date().setMonth(new Date().getMonth(), 1)).setHours(0, 0, 0, 0)), new Date()],
        label: 'Month To Date'
      },
      {
        value: [new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0), new Date()],
        label: 'Year To Date'
      }
    ],
    dateCustomClasses: this.dateCustomClasses
  };

  year = null;
  filterCustomerUID = 0;
  filterStatus: ScaleTicketStatusEnum[] = [];
  filterInvoiceUID = 0;
  filterDateFrom: Date = null;
  filterDateTo: Date = null;
  filterCustomer = '';
  filterMaterial: LU_MaterialService[] = [];

  constructor(
    private loginSvc: StarbaseLoginService
    ) { }

  ngOnInit(): void {
    this.generateInvoiceReportSteps = [
      new StarbaseWizardStep(
        'Range Selection',
        this.step1,
        'auto'
      ),
      new StarbaseWizardStep(
        'Customer Selection',
        this.step2,
        'auto'
      ),
    ];

    this.isAdmin = this.loginSvc.getUserModel().isAdmin();
    this.currentUser = this.loginSvc.getUserModel();
    if (!this.appGlobals.currentUser || this.appGlobals.currentUser !== this.currentUser.user) {
      this.appGlobals.currentUser = this.currentUser.user;
    }

    this.darkMode = this.appGlobals.getStoredDarkModeSetting();

    this.dropdownTypeDebounceTime = this.appGlobals.dropdownTypeDebounceTime;

    if (this.appGlobals.getStoredDarkModeSetting()) {
      this.bsConfig.containerClass = 'theme-default'
    }
    this.statuses = ScaleTicketHeader.GetStatusEnum();
  }

  dateRangeChange(val: Date[]) {
    this.filterDateFrom = val[0];
    this.filterDateTo = val[1];
    if (this.filterDateFrom > this.filterDateTo) {
      this.sbSvcProvider.notificationSvc.postNotification(
        this.sbSvcProvider.notificationSvc.notificationBuilder(
          'Invalid Date Range',
          'Please enter a valid Date Range'
      ));
    } else {
      // something to change to only customers active in date range
      this.customers = this.customers;
      this.generateInvoiceReportSteps[0].stepValidationFunc(null);
    }
    if (this.filterParams === null){
      this.filterParams = this.updateGeneralFilters(this.filterParams);
    }
    else{
      this.filterParams.clearFilterArray();
      this.filterParams = this.updateGeneralFilters(this.filterParams);
    }
    return;
  }

  setYear(){
    var year = (<HTMLInputElement>document.getElementById('year')).valueAsNumber;
    var dates = [];
    dates.push(new Date());
    dates.push(new Date());
    dates[0].setYear(year-1);
    dates[0].setMonth(11);
    dates[0].setDate(1);
    dates[0].setHours(0);
    dates[0].setMinutes(0);
    dates[0].setSeconds(0);
    dates[1].setYear(year);
    dates[1].setMonth(11);
    dates[1].setDate(0);
    dates[1].setHours(23);
    dates[1].setMinutes(59);
    dates[1].setSeconds(59);
    if(year >= 2020 && year <= new Date().getFullYear()){
      this.filterDateFrom = dates[0];
      this.filterDateTo = dates[1];
      if (this.filterParams == null){
        this.filterParams = this.updateGeneralFilters(this.filterParams);
      }
      else{
        this.filterParams.clearFilterArray();
        this.filterParams = this.updateGeneralFilters(this.filterParams);
      }
      this.generateInvoiceReportSteps[0].stepValidationFunc(null);
    }
    return;
  }

  generateReport(filters: FilterParams<ScaleTicketHeader>){
    this.filterParams = this.updateGeneralFilters(filters);
    this.filterParams = this.updateCustomerFilters(this.filterParams);
    // this.filter.setFirstSort("Job.Customer.Organization")
    // this.filter.addToSorts("Job.JobDescription")
    // this.filterParams = this.updateCustomerFilters(this.filterParams);
    this.wizardCompletedEmitter.emit(this.filterParams);
}


updateGeneralFilters(filters: FilterParams<ScaleTicketHeader>){
  this.filterStatus.forEach(x => {
    filters.addToFilter('ScaleTicketStatus', x.toString());
  });
  this.filterMaterial.forEach(x => {
    filters.addToFilter('MaterialUID', x.toString());
  })
  filters.addToFilter('ScaleTicketDateInFrom', this.filterDateFrom.toDateString());
  filters.addToFilter('ScaleTicketDateInTo', this.filterDateTo.toDateString());
  return filters;
}

updateCustomerFilters(filters: FilterParams<ScaleTicketHeader>){

  filters.addToFilter('Job.JobContactUID', this.customers.contactUID);
  return filters;
}

selectCustomer(customer: STContact) {

  if (customer) {
    this.customers = customer;
  } else {
    this.customers = undefined;
  }
  this.generateInvoiceReportSteps[1].stepValidationFunc(null);
}


} 